import { PageType } from './types';

export const PAGES = {
  ARTICLE: PageType.Article,
  CATEGORY: PageType.Category,
  SEARCH_RESULTS: PageType.SearchResults,
  HOMEPAGE: PageType.Homepage,
  TICKET: PageType.Ticket,
  HOME: PageType.Homepage,
  ROADMAP: PageType.RoadMap,
  PROFILE: PageType.Profile,
  CONTACT: PageType.Contact,
};

export const LOCALES = {
  DE: 'de',
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  HE: 'he',
  IT: 'it',
  JA: 'ja',
  KO: 'ko',
  NL: 'nl',
  PT: 'pt',
  RU: 'ru',
  TR: 'tr',
};

export const HEADER_FOOTER_SUPPORT_LANGUAGES = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'nl',
  'pt',
  'ru',
  'ja',
  'ko',
  'tr',
  'hi',
  'cs',
  'th',
  'zh',
  'uk',
  'vi',
  'id',
];

export const MOCKED_ROADMAP_LABELS = [
  {
    id: '5e2c392b-8762-4d09-8a0d-121de62d37d8',
    name: 'Roadmap: Wix Editor',
  },
  {
    id: 'ca8c47bc-ff69-4006-a0b7-b524906ecabe',
    name: 'Roadmap: Wix Bookings',
  },
  {
    id: 'c9a46fd8-6919-4969-a26c-dc03f5c60e25',
    name: 'Roadmap: Wix Blog',
  },
  { id: '18d84448-9998-4590-a9d8-098a8678b9a4', name: 'Roadmap: Velo' },
  {
    id: '9af919a1-8b25-4ce9-a4a5-d807519011ae',
    name: 'Roadmap: Wix Stores',
  },
];

export const EDITORS_NAMES = ['ADI', 'Wix Editor', 'Editor X'];

export const EDITORS_LABLES = {
  EDITOR_X: '4447d3a3-a0df-4e2b-b92d-3e4af55fb726',
  EDITOR: '211d1383-13a6-4bef-85d1-bf5eda11c8a7',
  ADI: '46758c8d-b75d-4046-9f49-ba6fbafe5b56',
};

export const URL_MSID_PATTERN =
  /[\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}/;

export const BI = {
  SOURCE_NAMES: {
    ARTICLE: 'article',
    SEARCH_RESULTS: 'search_results',
    CATEGORY: 'category',
    TICKET: 'ticket',
    HOME: 'home',
    PROFILE: 'user_profile',
    ROADMAP: 'roadmap',
    CONTACT: 'contact',
  },
  ITEM_TYPES: {
    KNOWN_ISSUE: 'known_issue',
    FEATURE_REQUEST: 'feature_request',
    ARTICLE: 'article',
    TICKET: 'ticket',
    PROFILE: 'user_profile',
  },
  ITEM_NAMES: {
    HELPFUL_VOTE_OPTION: 'helpful vote option',
  },
  CLICKED_ITEM_TYPES: {
    SECTION_EXPAND: 'section_expand',
    SECTION_COLLAPSE: 'section_collapse',
    ANCHOR: 'anchor',
    CATEGORY_SELECTION: 'category_selection',
    SUB_CATEGORY_SELECTION: 'sub_category_selection',
    ARTICLE_SELECTION: 'article_selection',
    FEATURE_REQUEST_SELECTION: 'feature_request_selection',
    KNOWN_ISSUE_SELECTION: 'known_issue_selection',
    HOME_PAGE: 'home_page',
    INTERNAL_LINK: 'internal_link',
    EXTERNAL_LINK: 'external_link',
    ARTICLE_LINK: 'article_link',
    CTA: 'CTA',
    RELATED_CONTENT: 'related_content',
    PICTURE: 'picture',
    ALL_TOPICS: 'all_topics',
    PAGE_ACTION: 'page_action',
    TRENDING_TOPICS: 'trending_topics',
    HIRE_A_WIX_PARTNER: 'hire_a_wix_partner',
    TAB_SELECTION: 'tab_selection',
    BREADCRUMBS: 'breadcrumbs',
  },
  USP: {
    TOOLTIP_MINIMIZED: 'minimized',
    TOOLTIP_OPEN: 'open',
    STATE: {
      ACTIVE: 'active',
      NOT_ACTIVE: 'not_active',
    },
    CLICKED_ITEM: {
      TOOLTIP_CLOSED: 'tooltip_closed',
      MAIN_CTA: 'main_cta',
      SECONDARY_CTA: 'secondary_cta',
      TOOLTIP_CLICK: 'tooltip_click',
    },
  },
  SELECTORS: {
    COLLAPSIBLE_COMPONENTS: '.collapsible-heading',
    CLICKABLE_IMAGES: 'img[class="clickable"]',
    ARTICLE_CTA_BUTTON: 'action-box-action-btn',
    PAGE: '#__next',
    HEADER: 'header',
    TABS: '.tab-heading',
  },
  SEARCH_RESULT_SELECTION: {
    SEARCH_BAR_DROPDOWN_LIST: 'search_bar_dropdown_list',
    FULL_SEARCH_RESULTS_LIST: 'full_search_results_list',
  },
  USER_ENGAGEMENT_PINGER_INTERVAL:
    process.env.NODE_ENV === 'test' ? 1000 : 10000,
};

export const PRODUCTION_DOMAIN = 'support.wix.com';

export const CHATBOT_URL =
  'https://www.wix.com/support-chatbot?t=2&alert=0&nodeId=RNc3EQNG7DHSFMjbPaLn&referral=';

export const WIX_CONTACT_URL =
  'https://www.wix.com/contact?&referral=answers_submit_ticket';

export const ANSWERS_API_BASE_URL = `https://${PRODUCTION_DOMAIN}/api/v1`;

export const API_CLIENT_ID = '57999a1b-940f-4227-adca-c554628ea935';

export const EXPERIMENTS = {
  ID: '__EXPERIMENTS__',
  SCOPES: ['customer-care'],
  SPECS: {
    REDIRECT_FROM_HELP_CENTER_ON_NOT_HELPED:
      'specs.engage.RedirectFromHelpCenterOnNotHelped',
    REDIRECT_FROM_HELP_CENTER_ONLY_BILLING_PREMIUM:
      'specs.engage.RedirectFromHelpCenterOnlyBillingPremium',
    SHOW_USP_TOOLTIP: 'specs.UspTooltip',
    BACKUP_CONTACT_PAGE: 'specs.backupContactPage',
    WIX_ROADMAP: 'specs.WixRoadmap',
    ARTICLE_FEEDBACK: 'specs.ArticleImprovedFeedback',
    SUB_SUB_CATEGORY_PAGE: 'specs.SubSubCategoryPage',
    HELP_CENTER_AB: 'specs.HelpCenterAB',
    READING_TIME: 'specs.ReadingTime',
  },
};

export const EMPTY_CATEGORY_ID = '00000000-0000-0000-0000-000000000000';

export const ARTICLES_PAGE_SIZE = 350;

export const SEARCH_ARTICLES_PAGE_SIZE = 20;

export const CATEGORY_ARTICLES_PAGE_SIZE = 20;

export const BILLING_AND_PREMIIUM_CATEGORIES = [
  'f78196b2-7b20-45d1-9ec2-3fb4504c6c38',
  '11af63e5-e36f-45c7-8596-031ac665e06d',
  '04e9f910-d5f6-44ea-b702-1646844dd106',
  'f2bb50e4-d721-4709-b94e-29b04d0d2451',
  'd3a9282e-b06f-4dc3-a973-1d36477461d7',
  '967ff141-bc5d-4a18-b664-10f7495da15e',
  '75c5cb39-36b5-4fe0-a7d2-2f4c1fae0ab3',
  'ce454447-8a62-4431-9b84-1ec3e3a1f46b',
  '2ec24e03-f797-4a78-939a-f1a02c9eb329',
  '35473554-6809-447f-916a-e38527ebcd39',
];

export const WIX_STATUS_DOMAIN = 'https://status.wix.com';

export const WIX_STATUS_PATH = '/api/v2/incidents.json';

export const SEO = {
  PLACEHOLDERS: {
    CATEGORY_TITLE: '$CATEGORY_TITLE',
    COMPANY_NAME: '$COMPANY_NAME',
    ARTICLE_TITLE: '$ARTICLE_TITLE',
    ARTICLE_PREVIEW: '$ARTICLE_PREVIEW',
  },
  COMPANY_NAME: 'Wix Support',
};

export const PAGE_TYPE_SEO_RPC = {
  ARTICLE: 'ARTICLE',
  CATEGORY: 'CATEGORY',
  CONTACT_PAGE: 'CONTACT_PAGE',
  HOME_PAGE: 'HOME_PAGE',
  SEARCH_RESULTS: 'SEARCH_RESULTS',
};

export const ONE_HOUR_MS = 3600000;

export const FEDOPS = {
  INTERACTION_NAMES: {
    SEARCH_ARTICLES: 'search_articles',
    VOTE_ARTICLE: 'vote_article',
    HELPFUL_ARTICLE: 'helpful_article',
    SUBMIT_TICKET: 'submit_ticket',
    ADDITIONAL_FEEDBACK: 'additional_feedback',
  },
};

export const SLED = {
  COOKIES: {
    PETRI_OVR: 'petri_ovr',
  },
  HEADERS: {
    DEPLOY_PREVIEW: 'x-wix-route-kb-client-nextjs',
  },
  QUERY_PARAMS: {
    X_WIX_ROUTE: 'x-wix-route',
  },
};

export const WIX_RECAPTCHA_KEY = '6Le_WGgdAAAAAPDQseS7wvNTDEYsdzlq1EOpyGQF';

export const SENTRY = {
  DSN: 'https://0a9ce445ac274d78ab1517888e5b6b4e@sentry-next.wixpress.com/761',
};

export const REDIS = {
  GET_HELP_CENTER_DATA: { KEY: 'getHelpCenterData', TTL: 300 },
  GET_CATEGORY_BY_URI: { KEY: 'getCategoryByUri', TTL: 300 },
  GET_PAGE_SEO: { KEY: 'getPageSeo', TTL: 300 },
  GET_TENANT_INFO: { KEY: 'getTenantInfo', TTL: 300 },
  GET_LABELS: { KEY: 'getLabels', TTL: 300 },
};

export const isInternalRoute = (url?: string): boolean =>
  !!url?.startsWith('/_next/data');

export const AGENT_TOOLBAR = {
  CLASSES: {
    OPEN: 'agent-toolbar-open',
    CLOSE: 'agent-toolbar-close',
    CONTAINER: 'user-toolbar-container',
  },
};

export const DEFAULT_SEARCH_METHOD = 'Answers';

export const COOKIES = {
  WIX_CLIENT_ID: '_wixCIDX',
  WIX_LANGUAGE: 'wixLanguage',
  WIX_CLIENT: 'wixClient',
  WIX_ANSWERS_CLIENT_ID: '_AC',
  WIX_UID: '_wixUIDX',
};

export const LOCAL_STORAGE_PREFIX = {
  FEEDBACK_VOTE: 'feedback-vote-',
  ADDITIONAL_FEEDBACK_OPTION: 'additional-feedback-',
};
export const ALL_PRODUCTS_LABEL_ID = '0000000000000';
